// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1rdMD","error":"Textarea_error__1tT6L","readonly":"Textarea_readonly__16WAb","disabled":"Textarea_disabled__1FT70"};